import { ActionReducerMap, MetaReducer } from '@ngrx/store';
import {
  routerReducer as router,
  RouterReducerState,
} from '@ngrx/router-store';
import { Type } from '@angular/core';

export interface RootState {
  router: RouterReducerState;
}

export const rootReducers: ActionReducerMap<RootState> = {
  router,
};

export const rootMetaReducers: MetaReducer<RootState>[] = [];

export const rootEffects: Type<any>[] = [];
